import { PencilRuler, DraftingCompass, Workflow, CalendarClock } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const ITEMS = [
  {
    icon: PencilRuler,
    tint: "text-arcblue",
    title: "In-House Architect",
    copy: "Professional architectural expertise from concept to plans.",
  },
  {
    icon: DraftingCompass,
    tint: "text-arcgreen",
    title: "Custom Designs",
    copy: "Homes designed around your lifestyle, block and needs.",
  },
  {
    icon: Workflow,
    tint: "text-arcorange",
    title: "End-to-End Service",
    copy: "One team managing the journey from design through construction.",
  },
  {
    icon: CalendarClock,
    tint: "text-arcpurple",
    title: "Up to 6-Month Handover",
    copy:
      "A streamlined approach designed to move projects efficiently toward completion, subject to approvals and project requirements.",
  },
];

export default function TrustStrip() {
  return (
    <section className="bg-cream border-b border-line" data-testid="trust-strip">
      <div className="max-w-[1440px] mx-auto px-5 sm:px-8 lg:px-12 py-12 sm:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-0 lg:divide-x lg:divide-line">
          {ITEMS.map((item, i) => (
            <Reveal key={item.title} delay={i * 0.08}>
              <div className="lg:px-8 first:lg:pl-0 flex flex-col gap-3" data-testid={`trust-item-${i}`}>
                <item.icon size={26} strokeWidth={1.4} className={item.tint} />
                <h3 className="font-serif text-xl font-medium text-charcoal">{item.title}</h3>
                <p className="text-sm leading-relaxed text-mist">{item.copy}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
